<template>
  <div>
    <!-- 物流号修改 -->
    <el-dialog :title="$t('message.logisticsNumberModification')" :close-on-click-modal="false"
      :close-on-press-escape="!submitting" :show-close="!submitting"
      :visible.sync="$parent.updateExpressDialogVisible" width="560px" center>
      <div v-loading="submitting" element-loading-text="处理中，请稍候">
        <div class="content">
          <div class="label">
            {{ $t("message.originalLogisticsNumber") }}：
          </div>
          <div class="val">
            <el-checkbox-group v-model="checkedExpressKeys" class="express-list" :disabled="submitting">
              <el-checkbox v-for="(item, index) in expressList" :key="getExpressKey(item, index)"
                :label="getExpressKey(item, index)">
                <span>{{ item.express_no }}</span>
                <span v-if="item.purchase_no" class="purchase-no">({{ item.purchase_no }})</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="content">
          <div class="label">
            {{ $t("message.modifiedLogisticsNumber") }}：
          </div>
          <div class="val">
            <el-input v-model="express_no_new" :disabled="submitting" onfocus="this.select()"></el-input>
          </div>
        </div>
        <el-progress v-if="submitting || progressTotal" :percentage="progressPercentage"
          :format="formatProgress"></el-progress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submitting" @click="$parent.updateExpressDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <el-button type="primary" :loading="submitting" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    expressList: { type: Array, default: () => [] },
    ids: { type: Array },
  },
  data() {
    return {
      checkedExpressKeys: [],
      express_no_new: "",
      submitting: false,
      progressDone: 0,
      progressTotal: 0,
    };
  },
  computed: {
    selectedExpressList() {
      return this.expressList.filter((item, index) =>
        this.checkedExpressKeys.includes(this.getExpressKey(item, index))
      );
    },
    progressPercentage() {
      if (!this.progressTotal) return 0;
      return Math.round((this.progressDone / this.progressTotal) * 100);
    },
  },
  watch: {
    expressList: {
      immediate: true,
      handler() {
        this.checkedExpressKeys = this.expressList.map((item, index) => this.getExpressKey(item, index));
      },
    },
  },
  methods: {
    getExpressKey(item, index) {
      return `${item.order_purchase_id || ""}_${item.id || index}_${item.express_no}`;
    },
    formatProgress() {
      return `${this.progressDone}/${this.progressTotal}`;
    },
    async save() {
      if (this.selectedExpressList == false)
        return this.$message.error(
          this.$t("message.pleaseEnterTheLogisticsNumber")
        );
      if (this.express_no_new == "")
        return this.$message.error(
          this.$t("message.pleaseEnterTheLogisticsNumber")
        );
      this.submitting = true;
      this.progressDone = 0;
      this.progressTotal = this.selectedExpressList.length;
      let res = null;
      try {
        for (const item of this.selectedExpressList) {
          res = await this.$api.orderApi.updateExpress({
            orderPurchaseIdSet: [item.order_purchase_id],
            express_no: item.express_no,
            express_no_new: this.express_no_new,
          });
          this.progressDone += 1;
        }
        this.$message.success(res.msg);
        this.$parent.wuliuSuccess();
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px 20px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;

    /deep/.el-input {
      width: 100%;
    }

    .express-list {
      max-height: 320px;
      overflow-y: auto;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 8px 12px;

      /deep/.el-checkbox {
        display: block;
        margin: 0 0 8px;
        line-height: 24px;
      }

      .purchase-no {
        color: #909399;
        margin-left: 6px;
      }
    }
  }
}
</style>
